/* eslint-disable consistent-return */
const MAX_FILE_NAME = 20;

const getFileNameDisplay = (fileName, size = MAX_FILE_NAME) => {
  if (!fileName) return;

  let result = fileName;

  const parts = fileName.split('.');
  const name = parts[0];
  const extension = parts[1];

  if (name.length > size) {
    const middle = Math.floor(size / 2);
    result = `${name.substring(0, middle)}...${name.substring(name.length - middle, name.length)}.${extension}`;
  }

  return result;
};

const openFileURL = url => {
  if (url) window.open(url, '_blank');
};

export { getFileNameDisplay, openFileURL };
